module.exports = __webpack_public_path__ + "img/icon-orders.c7c3efc8.svg";